import { render, staticRenderFns } from "./routerview.vue?vue&type=template&id=2d77dac6"
import script from "./routerview.vue?vue&type=script&lang=js"
export * from "./routerview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports